/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './facet.defs'
export { main as default } from './facet.defs'
